// client/src/lib/api/notifications-api.ts
// ===========================================
// MÓDULO DE NOTIFICACIONES
// Maneja la obtención, marcado como leído y conteo de notificaciones.
// Usa apiRequest para inyectar headers y manejar errores de forma tipada.
// ===========================================

import { apiRequest } from "./api-client";

// -------------------------------------------
// Obtener notificaciones de una tienda
// -------------------------------------------
// COMENTARIO: apiRequest obtiene el JSON completo. Extraemos response.data
// para mantener la estructura exacta que ya consumen los componentes.
export async function getShopNotifications(shopId: string): Promise<any[]> {
  const response = await apiRequest<{ data: any[] }>(
    `/api/shops/${shopId}/admin-notifications`,
  );
  return response.data;
}

// -------------------------------------------
// Marcar una notificación como leída
// -------------------------------------------
export async function markNotificationAsRead(
  notificationId: string,
): Promise<void> {
  return apiRequest<void>(`/api/notifications/${notificationId}/read`, {
    method: "PATCH",
  });
}

// -------------------------------------------
// Marcar todas las notificaciones como leídas
// -------------------------------------------
export async function markAllNotificationsAsRead(
  shopId: string,
): Promise<void> {
  return apiRequest<void>(`/api/shops/${shopId}/notifications/read-all`, {
    method: "PATCH",
  });
}

// -------------------------------------------
// Obtener conteo de notificaciones no leídas
// -------------------------------------------
export async function getUnreadNotificationCount(
  shopId: string,
): Promise<number> {
  const response = await apiRequest<{ count: number }>(
    `/api/shops/${shopId}/notifications/unread-count`,
  );
  return response.count || 0;
}
